export const MainViewId = "mainView";

export const DefaultOauthLink = "./";
export const LoginPath = "login";
export const LoginLink = `${LoginPath}?signin=`;
export const ForgotPasswordLink = "reset?signin=";
export const CreateNextStepLink = "create?signin=";
